import { IChooseItems } from '../../../../components/mainContent/TableAllDishes'
import { IEdgeServers } from '../../../../core/api/dto/BuffetDishDto'
import React, { useState } from 'react'
import {
  AppNotification,
  NotificationType,
} from '../../../../components/notification/Notification'
import { useTranslation } from 'react-i18next'
import { IPlanMenuTypeDto } from '../../../../core/api/dto/PlanMenuTypeDto'
import {
  useDeleteGuestTypeToFotoboxesMutation,
  useSendGuestTypeToFotoboxesMutation,
} from '../../../../core/api/GuestTypeApi'
import { uniqFilter } from '../../DishesPage/hooks/useSentOnFotobox'

interface UseSentGuestTypeOnFotoboxProps {
  chooseItems: IChooseItems | null
  tableData: IPlanMenuTypeDto[]
  setChooseItems: React.Dispatch<React.SetStateAction<IChooseItems | null>>
}

interface UseSentGuestTypeOnFotoboxResponse {
  isDeleteMode: boolean
  deleteStations: IEdgeServers[] | null
  sentPopup: boolean
  closeSentPopup: () => void
  openDeleteStationPopup: () => void
  openSentPopup: () => void
  onSendGuestType: (value: string[]) => void
  onDeleteGuestTypeStation: (value: string[]) => void
  isLoadingSend: boolean
}

export const useSentGuestTypeOnFotobox = ({
  tableData,
  chooseItems,
  setChooseItems,
}: UseSentGuestTypeOnFotoboxProps): UseSentGuestTypeOnFotoboxResponse => {
  const { t } = useTranslation()
  const [sentPopup, setSentPopup] = useState(false)
  const [isDeleteMode, setIsDeleteMode] = useState(false)
  const [deleteStations, setDeleteStations] = useState<IEdgeServers[] | null>(
    null,
  )

  const [sendGuestTypeToFotoboxes, { isLoading: isLoadingSend }] =
    useSendGuestTypeToFotoboxesMutation()
  const [deleteGuestTypeToFotoboxes] = useDeleteGuestTypeToFotoboxesMutation()

  const chooseGuestType = tableData
    .filter((item) => chooseItems && chooseItems[item.id] && !item.archived)
    .map((item) => item.guid)

  const closeSentPopup = () => {
    setSentPopup(false)
    setIsDeleteMode(false)
    setDeleteStations(null)
  }
  const openDeleteStationPopup = () => {
    setSentPopup(true)
    setIsDeleteMode(true)
    const deleteStation = uniqFilter(
      tableData
        .filter((item) => chooseItems && chooseItems[item.id] && !item.archived)
        .map((item) => item.edgeServers)
        .flat(1),
    )
    setDeleteStations(deleteStation)
  }
  const openSentPopup = () => setSentPopup(true)

  const onSendGuestType = (value: string[]) => {
    if (value.length && chooseGuestType.length) {
      sendGuestTypeToFotoboxes({
        planMenuGuestTypesGuids: chooseGuestType,
        edgeServersGuids: value,
      })
        .unwrap()
        .then(() => {
          AppNotification({
            type: NotificationType.success,
            msg: t('Типы гостей успешно отправлены на выбранные станции'),
          })
          setChooseItems(null)
          setSentPopup(false)
        })
    }
  }
  const onDeleteGuestTypeStation = (value: string[]) => {
    if (value.length && chooseGuestType.length) {
      deleteGuestTypeToFotoboxes({
        planMenuGuestTypesGuids: chooseGuestType,
        edgeServersGuids: value,
      })
        .unwrap()
        .then(() => {
          AppNotification({
            type: NotificationType.success,
            msg: t('Типы гостей успешно удалены с выбранных станций'),
          })
          setChooseItems(null)
          setSentPopup(false)
          setIsDeleteMode(false)
          setDeleteStations(null)
        })
    }
  }

  return {
    isDeleteMode,
    deleteStations,
    sentPopup,
    closeSentPopup,
    openSentPopup,
    openDeleteStationPopup,
    onDeleteGuestTypeStation,
    onSendGuestType,
    isLoadingSend,
  }
}
